<div
  class="side-nav-shell side-nav-shell--frameless"
  [class.side-nav-shell--collapsed]="railCollapsed()"
  [class.side-nav-shell--width-animating]="isWidthAnimating()"
  [style.--side-nav-expanded-width]="expandedWidth()"
  [style.--side-nav-collapsed-width]="collapsedWidth()"
  [style.--side-nav-icon-size]="iconSize()"
>
  <ng-container *ngTemplateOutlet="navBody" />
</div>

<ng-template #navBody>
  <div class="side-nav__mobile">
    <label for="side-nav-section-select">{{ title() }}</label>
    <div class="side-nav__mobile-select-wrap enr-radius-8">
      <mat-icon aria-hidden="true">tune</mat-icon>
      <select
        id="side-nav-section-select"
        [value]="activeItemId() ?? ''"
        (change)="onCompactChange($event)"
      >
        @for (option of compactLeafOptions(); track option.item.id) {
        <option [value]="option.item.id">
          {{ option.groupLabel }} — {{ option.item.label }}
        </option>
        }
      </select>
      <mat-icon aria-hidden="true">expand_more</mat-icon>
    </div>
  </div>

  <nav
    class="side-nav flex h-auto min-h-0 flex-col overflow-visible text-(--nav-ink)"
    [attr.aria-label]="ariaLabel()"
  >
    @if (pinnedItems().length) {
    <ul
      class="side-nav__rail menu-list flex min-h-0 flex-none flex-col content-start justify-start gap-0.5 overflow-visible px-1.5 pb-2"
    >
      @for (item of pinnedItems(); track item.id) {
      <ng-container
        *ngTemplateOutlet="
          menuNode;
          context: { item: item, ancestors: [], level: 0 }
        "
      />
      }
    </ul>
    }

    <ul
      class="side-nav__rail menu-list flex min-h-0 flex-none flex-col content-start justify-start gap-0.5 overflow-visible px-1.5 pb-2"
    >
      @if (filteredItems().length) { @for (item of filteredItems(); track
      item.id) {
      <ng-container
        *ngTemplateOutlet="
          menuNode;
          context: { item: item, ancestors: [], level: 0 }
        "
      />
      } } @else if (!pinnedItems().length) {
      <li
        class="grid justify-items-center gap-1 px-3 py-8 text-center text-xs text-(--nav-muted)"
      >
        <mat-icon aria-hidden="true">search_off</mat-icon>
        <strong class="text-(--nav-ink)">{{ emptyTitle() }}</strong>
        <span>{{ emptyHint() }}</span>
      </li>
      }
    </ul>
  </nav>
</ng-template>

<ng-template
  #menuNode
  let-item="item"
  let-ancestors="ancestors"
  let-level="level"
>
  <li
    class="side-nav__group menu-item"
    [class.has-children]="hasChildren(item)"
    [class.active]="level === 0 && isBranchActive(item)"
    [class.submenu-active]="level > 0 && isItemActive(item)"
    [class.expanded]="hasChildren(item) && isItemExpanded(item.id)"
    [class.level-0]="level === 0"
    [class.level-1]="level === 1"
    [class.level-2]="level === 2"
    [class.level-3]="level >= 3"
    [class.divider-after]="item.dividerAfter"
    [class.divider-before]="item.dividerBefore"
    [class.disabled]="item.disabled"
    [class.maintenance]="item.disabled"
  >
    @if (level === 0 && collapsedInteraction() === 'menu' && railCollapsed()) {
    <div class="side-nav__collapsed-content">
      @if (shouldOpenCollapsedMenu(item)) {
      <enr-menu
        #collapsedMenu
        class="contents"
        [position]="'right-start'"
        [heading]="item.label"
        [items]="buildMenuItems(item.children ?? [])"
        [activeItemId]="activeItemId()"
        [iconTemplate]="
          hasItemIcons(item.children ?? []) ? collapsedMenuIconTpl : null
        "
        (itemSelect)="onCollapsedMenuSelect(item, $event)"
      >
        <button
          enrMenuTrigger
          type="button"
          class="side-nav__collapsed-trigger relative overflow-hidden"
          matRipple
          [class.side-nav__collapsed-trigger--active]="isBranchActive(item)"
          [attr.aria-label]="item.label"
          [attr.aria-expanded]="collapsedMenu.isOpen()"
          [enrTooltip]="item.label"
          enrTooltipPosition="right"
          [enrTooltipShowDelay]="0"
          (click)="onCollapsedMenuActivate(collapsedMenu)"
        >
          <span class="side-nav__group-glyph menu-icon">
            @if (iconTemplate(); as customIcon) {
            <ng-container
              *ngTemplateOutlet="customIcon; context: { $implicit: item, icon: item.icon ?? '', collapsed: true }"
            />
            } @else {
            <app-menu-icon [icon]="item.icon ?? ''" />
            }
          </span>
        </button>
      </enr-menu>
      } @else {
      <button
        type="button"
        class="side-nav__collapsed-trigger relative overflow-hidden"
        matRipple
        [class.side-nav__collapsed-trigger--active]="isBranchActive(item)"
        [attr.aria-label]="item.label"
        [enrTooltip]="item.label"
        enrTooltipPosition="right"
        [enrTooltipShowDelay]="0"
        (click)="onCollapsedSoleLeafActivate(item, ancestors)"
      >
        <span class="side-nav__group-glyph menu-icon">
          @if (iconTemplate(); as customIcon) {
          <ng-container
            *ngTemplateOutlet="customIcon; context: { $implicit: item, icon: item.icon ?? '', collapsed: true }"
          />
          } @else {
          <app-menu-icon [icon]="item.icon ?? ''" />
          }
        </span>
      </button>
      }
    </div>
    } @else if (level === 0) {
    <div class="side-nav__collapsed-content">
      <button
        type="button"
        class="side-nav__collapsed-trigger relative overflow-hidden"
        matRipple
        [class.side-nav__collapsed-trigger--active]="isBranchActive(item)"
        [attr.aria-label]="item.label"
        [enrTooltip]="item.label"
        enrTooltipPosition="right"
        [enrTooltipShowDelay]="0"
        (click)="onItemActivate(item, ancestors)"
      >
        <span class="side-nav__group-glyph menu-icon">
          @if (iconTemplate(); as customIcon) {
          <ng-container
            *ngTemplateOutlet="customIcon; context: { $implicit: item, icon: item.icon ?? '', collapsed: true }"
          />
          } @else {
          <app-menu-icon [icon]="item.icon ?? ''" />
          }
        </span>
      </button>
    </div>
    }

    <div class="side-nav__expanded-content">
      <button
        type="button"
        class="menu-content"
        matRipple
        [class.side-nav__group-toggle]="hasChildren(item)"
        [class.side-nav__group-toggle--active]="
          hasChildren(item) && isBranchActive(item)
        "
        [class.side-nav__leaf]="!hasChildren(item)"
        [class.side-nav__item-ripple-clip]="level > 0 && !hasChildren(item)"
        [class.side-nav__leaf--active]="
          !hasChildren(item) && isItemActive(item)
        "
        [disabled]="item.disabled"
        [attr.aria-expanded]="
          hasChildren(item) ? isItemExpanded(item.id) : null
        "
        [attr.aria-current]="
          !hasChildren(item) && isItemActive(item) ? 'page' : null
        "
        (click)="onItemActivate(item, ancestors)"
      >
        @if (item.icon) {
        <div class="side-nav__group-glyph menu-icon">
          @if (iconTemplate(); as customIcon) {
          <ng-container
            *ngTemplateOutlet="customIcon; context: { $implicit: item, icon: item.icon ?? '', collapsed: false }"
          />
          } @else {
          <app-menu-icon [icon]="item.icon" />
          }
        </div>
        }
        <span class="side-nav__group-label menu-text">{{ item.label }}</span>
        @if (hasChildren(item)) {
        <div class="side-nav__chevron menu-arrow">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        }
      </button>

      @if (hasChildren(item)) {
      <div
        class="side-nav__submenu-panel submenu-panel"
        [class.side-nav__sections--collapsed]="
          !isItemExpanded(item.id)
        "
        [attr.aria-hidden]="railCollapsed() || !isItemExpanded(item.id)"
        [attr.inert]="
          railCollapsed() || !isItemExpanded(item.id) ? '' : null
        "
      >
        <ul class="side-nav__sections submenu">
          @for (child of item.children; track child.id) {
          <ng-container
            *ngTemplateOutlet="
              menuNode;
              context: {
                item: child,
                ancestors: ancestors.concat([item]),
                level: level + 1,
              }
            "
          />
          }
        </ul>
      </div>
      }
    </div>
  </li>
</ng-template>

<ng-template #collapsedMenuIconTpl let-icon="icon">
  @if (icon) {
  <app-menu-icon [icon]="icon" />
  }
</ng-template>
